export default __webpack_public_path__ + "static/media/discord-large.2f362146.webp";